const search = {
  myGoods: () =>
    import("@/common/SearchTransitionPage/common/myGoodsSearch"), //我的商品搜索
  myNft: () =>
    import("@/common/SearchTransitionPage/common/myNftSearch"), //我的Nft搜索
  myOrder: () =>
    import("@/common/SearchTransitionPage/common/myOrderSearch"), //我的记录搜索
  mylocker: () =>
    import(
      "@/common/SearchTransitionPage/common/mylockerSearch"
    ), //我的locker搜索
  nftsHome: () =>
    import(
      "@/common/SearchTransitionPage/common/nftsHomeSearch"
    ), //nfts搜索
  dealings: () =>
    import(
      "@/common/SearchTransitionPage/common/dealingsSearch"
    ), //dealings搜索
  Synthesize: () =>
    import(
      "@/common/SearchTransitionPage/common/SynthesizeSearch"
    ), //Synthesize
  raffle: () =>
    import("@/common/SearchTransitionPage/common/raffleSearch"), //raffle
  convertible: () =>
    import(
      "@/common/SearchTransitionPage/common/convertibleSearch"
    ), //convertible
};
export default search;
